import { actions as uiActions, selectors as uiSelectors } from 'ducks/ui';
import { actions as operationActions } from 'ducks/uiOperations';
import { actions as formActions } from 'ducks/form';
import { selectors as importShipmentsSelectors, actions as importShipmentsActions } from 'ducks/purchaseOrderEnquiry/ldInTransitImportShipments';
import { searchImportShipments } from 'api/purchaseOrderEnquiry/ldInTransit';
import { selectors as orderSelectors } from 'ducks/purchaseOrderEnquiry/purchaseOrder';
import { selectors as orderLineSelectors } from 'ducks/purchaseOrderEnquiry/purchaseOrderLine';

const params = new URLSearchParams(location.search);

export const mapStateToProps = state => ({
  gridName: 'InTransitImportShipments',
  columnDefs: importShipmentsSelectors.Columns(state),
  isCustomerLookUpOpen: uiSelectors.isCustomerLookUpOpen(state), //to trigger update size based on drawer state change
  actions: importShipmentsSelectors.Actions(state),
  gridOptions: importShipmentsSelectors.gridOptions(state),
  isLoading: importShipmentsSelectors.isLoading(state),
  apiMethod: searchImportShipments,
  reqParams: (orderSelectors.selected(state) || params.get('PurchaseOrder')) && (orderLineSelectors.selectedOrderLine(state) || params.get('LineNumber'))
   &&
    {
      PurchaseOrder: (orderSelectors.selected(state) && orderSelectors.selected(state).PurchaseOrder) || params.get('PurchaseOrder'),
      LineNumber: (orderLineSelectors.selectedOrderLine(state) && orderLineSelectors.selectedOrderLine(state).LineNumber) || params.get('LineNumber'),
    },
  keyFields: [{ valueField: 'PurchaseOrderLineNumber', routeField: 'LineNumber' }],
});

export const actions = {
  deleteSelectedRecords: importShipmentsActions.remove,
  changeSelectedTab: uiActions.changeSelectedTab,
  changeOperationMode: operationActions.changeOperationMode,
  getFormSchema: formActions.search,
  changeSelectedForm: formActions.setSelected,
  setSelectedOrderLine: importShipmentsActions.setSelected
}
